import React, { useEffect, useState } from "react";
import { CreacionProduccionApi } from "../api/CreacionProduccionApi";
import { NotificationManager } from "react-notifications";
import {
    dateToDayEnd,
    dateToDayStart,
    getErrorFromResponse,
} from "../../../../../../../../utility/utils";
import { useForm } from "react-hook-form";
import { ESTADOS_PRODUCCION } from "../../../../../../../../utility/constants";
import { getWeekOfDate } from "../../../../helpers/dateRange";

export const useProduccionForm = (regresar) => {
    const {
        crearProduccion,
        getDetalleProduccion,
        getSiguienteNumeroProduccion,
        cargando,
    } = CreacionProduccionApi();

    const [ordenesProduccion, setOrdenesProduccion] = useState([]);

    const { semana: semanaActual, anio: anioActual } = getWeekOfDate();

    const {
        control: formControl,
        register: formRegister,
        setValue: formSetValue,
        getValues: formGetValues,
        trigger: validateForm,
        watch: formWatch,
        formState: { errors: formErrors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            anio: anioActual,
            semana: semanaActual,
        },
    });

    const anio = formWatch("anio");

    const FormSubmit = async () => {
        const valid = await validateForm();
        if (!valid) return;

        // si no hay ordenes de producción, mostrar advertencia
        if (ordenesProduccion.length === 0) {
            NotificationManager.warning(
                "Debe agregar al menos una orden de producción",
                "Advertencia",
                3000,
            );
            return;
        }

        const formValues = formGetValues();

        const body = {
            anio: formValues.anio,
            semana: formValues.semana,
            fecha_inicial: dateToDayStart(formValues.fecha_inicial),
            fecha_final: dateToDayEnd(formValues.fecha_final),
            ordenes_produccion: ordenesProduccion.map((orden) => ({
                id: orden.id ? orden.id : undefined,
                kg_a_producir: orden.kg_a_producir,
                evs_id: orden.evs.id,
                estado: orden.estado,
            })),
        };

        await CrearProduccion(body);
    };

    const CrearProduccion = async (body) => {
        try {
            // Lógica para guardar la gestión de almacén
            await crearProduccion(body);

            NotificationManager.success(
                "Producción creada con éxito",
                "Éxito",
                3000,
            );

            regresar();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al crear la producción",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const GetSiguienteNumeroProduccion = async (anio) => {
        try {
            const numero = await getSiguienteNumeroProduccion({ anio });
            formSetValue("numero", numero);
        } catch (error) {
            console.error(
                "Error al obtener el siguiente número de producción:",
                error,
            );
        }
    };

    useEffect(() => {
        GetSiguienteNumeroProduccion(anio);
    }, [anio]);

    return {
        formControl,
        formRegister,
        formErrors,
        formWatch,
        formGetValues,
        formSetValue,

        ordenesProduccion,
        setOrdenesProduccion,
        FormSubmit,
        cargando,
    };
};
